import type { FC } from 'react';
import { useState } from 'react';
import { Flex, VStack } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { Header } from '../../../../ui-components';
import { ForgotPasswordForm } from './forgot-password-form/ForgotPasswordForm';
import { ForgotPasswordSubmitted } from './forgot-password-submitted/ForgotPasswordSubmitted';
import type { UserLogin } from '../login/Login';

interface LocationState {
    email?: string;
}

const ForgotPassword: FC = () => {
    const location = useLocation<LocationState>();
    const [submitted, setSubmitted] = useState(false);
    const form = useForm<UserLogin>({
        defaultValues: { email: location.state?.email !== undefined ? location.state.email : '' },
    });

    return (
        <div
            className="flex h-full w-full justify-center"
            data-testid="account-forgot-password-main-container"
        >
            <Flex
                width="100%"
                maxWidth={{ base: '100%', md: '680px' }}
                padding={0}
                pt={{ base: 4, sm: 8 }}
                pb={16}
            >
                <VStack spacing={4} width="100%" padding={0}>
                    <Flex px={{ base: 4, sm: 8, md: 0 }} justifyContent="start" width="100%">
                        <Header
                            as="h3"
                            variant="header3"
                            id="account-forgot-password-title"
                            style="bold"
                            color="slt-pepper.1000"
                        >
                            <FormattedMessage
                                id="account.forgot-password.title"
                                defaultMessage="Forgot your password?"
                            />
                        </Header>
                    </Flex>

                    {submitted ? (
                        <ForgotPasswordSubmitted
                            email={form.getValues('email')}
                            setSubmitted={setSubmitted}
                        />
                    ) : (
                        <ForgotPasswordForm form={form} setSubmitted={setSubmitted} />
                    )}
                </VStack>
            </Flex>
        </div>
    );
};

export { ForgotPassword };
